import { politicalParties } from '../../constants/api';
import useRESTData from './useRESTData';
import classNames from 'classnames';

// Given an array of ids, retrieve the sum of previous seats
const getPreviousSeats = (ids, parties) =>
  ids.reduce((result, id) => (parties[id] ? parties[id].seats : 0) + result, 0);

// Convert the partyResult array into an object
const arrayToDict = (array, field = 'id') =>
  array.reduce((result, party) => {
    result[party[field]] = party;
    return result;
  }, {});

export default (currentData, pastData) => {
  const matchParties = useRESTData(`${politicalParties}`);

  //Ñapa para MÁS PAÍS solo en A3N
  const host = window.location.hostname.replace('localhost', 'lasexta');
  const idNoCount = host.indexOf('antena3') !== -1 && 43;
  //const idNoCount = null;

  if (
    !matchParties ||
    !currentData ||
    !currentData.partiesResult ||
    !pastData ||
    !pastData.partiesResult
  ) {
    return null;
  }

  const partyFormats = arrayToDict(matchParties, 'currentId');
  const dictPastData = arrayToDict(pastData.partiesResult);

  return currentData.partiesResult.map(party => {
    const partyFormat = partyFormats[party.id];
    const previousSeat =
      party.id === idNoCount
        ? 0
        : getPreviousSeats(
            partyFormat ? [partyFormat.previousIds] : [party.id],
            dictPastData
          );

    const difference = party.seats - previousSeat;
    const symbolClassName = classNames([
      'partyEscanos',
      {
        less: difference < 0,
        more: difference > 0,
        equal: difference === 0
      }
    ]);

    return {
      ...party,
      difference,
      symbolClassName,
      previousSeat
    };
  });
};
